import { router } from "@smakecloud/api-client-helper";
import { list } from "./list";

export const BasicSettingsLocales = router({
    list,
});
